<template>
  <div style="width:100%">
    <div class="container" v-loading="loading">
      <!-- 顶部按钮 -->
      <div class="topBtnPart">
        <div class="topBtn" style="margin-right:10px;">return to main page <span style="text-decoration: underline; margin-left:5px;" @click="returnHome"> https://wch-ic.com/</span></div>
        <a style="display:inline-block;" class="topBtn" :href="downloadHref"><i class="el-icon-download"></i> export</a>
      </div>
      <!-- 表格区域 -->
      <div v-if="tableData&&tableData.length>0" >
          <div  v-for="(item,index) in tableData" :key="index" class="tableContainer">
            <div class="tableTitle">
              {{item.title}}
            </div>
            <el-table :data="item.value" :max-height='tableMaxHeight'  border :header-cell-style='getHeadClass' :cell-class-name="cellClassName"  :row-class-name="tableRowClassName">
              <el-table-column :fixed='i==0 ? true: null'  v-for="(t,i) in item.meta" :key="i" :min-width="t.field=='Package'?'220px':'auto'" :width="setColumnWidth(t,i,item)" 
               :label="t.title" :property="t.field" align='center' >
              <!-- :width="i==0?130:t.width" :width="i==0?130:'100%'"  :width="setColumnWidth(t,i)"   :width="flexColumnWidth(t.title, item.value)"-->
                  <template slot-scope="scope">
                      <span v-if="t.head==1">
                          <a v-if="scope.row.url" class="cellClass" style="color:#005eb1; font-size:12px; cursor:pointer; text-align:center; font-weight:600;text-decoration:none;" :href="scope.row.url" target="_blank" >{{scope.row[scope.column.property]}}</a>
                          <span class="cellClass" v-else style="font-size:12px;color:#005eb1;text-align:center; font-weight:600;text-decoration:none;">
                              {{scope.row[scope.column.property]}}
                          </span>
                      </span>
                      <span v-else class="cellClass">
                          <span v-if="scope.row[scope.column.property]" v-html="scope.row[scope.column.property]"></span>
                          <span v-else>-</span>
                      </span>
                  </template>
              </el-table-column>
            </el-table>
          </div>
          
      </div>
      <!-- 底部注释 -->
      <div class="bottomTips">
        <p >*D=USB Device Controller</p>
        <p >*H/D=USB Host Controller and USB Device Controller</p>
      </div>
    </div>

  </div>
</template>

<script>
import { getAction, postAction, postFormAction, downFile} from '@/request/http'//引入封装的get post方法
import axios from 'axios'
export default {
  name: "Home",
  components:{
  },
  data() {
    return {
        loading:false,
        tableData:[],
        tableMaxHeight:800,
        downloadHref:window._CONFIG['domianURL']+'/api/official/website/productTables/enDownload',
        url:{
          mcuUrl:'/api/official/website/productTables/getEnMcuProductTable',
          downloadUrl:'/api/official/website/productTables/enDownload'
        },
        loading_export:false,
    };
  },
  computed: {
  },
  watch:{
  },
  mounted() {
    this.setTableHeight()
    this.getTableData()
  },
  activated(){
  },
  methods:{
    //获取浏览器高度
    setTableHeight(){
      console.log('高度',  window.screen.availHeight)//window.screen.height
      let height = window.screen.availHeight
      if(height<=1000){
        debugger
        this.tableMaxHeight=600
      }else{
        this.tableMaxHeight=800
      }
    },

    //获取mcu表格
    getTableData(){
      getAction(this.url.mcuUrl)
        .then(res => {
          this.loading = true;
          
          if(res.data.code===0 && res.data.data.length){
            this.tableData = res.data.data
            this.tableData.forEach(item=>{
                item.meta = JSON.parse(item.meta)
                item.value = JSON.parse(item.value)

                item.value.forEach((t)=>{
                  if(t.url.indexOf('wch-ic')==-1){
                    t.url = 'https://www.wch-ic.com'+t.url
                  }
                })
            })
            console.log('tableData',this.tableData)
          }else{
            this.$message.error(res.data.message);
          }
          this.loading = false;
      });
    },

   
    //设置表格部分列宽度
    setColumnWidth(t,i,item){
      // 62=E8051 USB 系列； 33=RISC极简汇编系列

     if(i==0){
      return '130px';
     }else if(t.field=="UART"){
      return '54px'
     }else if(t.field=='SDIO'){
      return '54px'
     }else if(t.field=="SPI"){
      return '54px'
     }else if(t.field=='FSMC'){
      return '54px'
     }else if(t.field=='TRNG'){
      return '54px'
     }else if(t.title=="I/O"){
      return '54px'
     }else if(t.field=='Freq'){
      return '80px'
     }else if(t.field=='VDD'){
      if(item.id==71){//8051
        return '120px'
      }else{
        return '80px'
      }
     }else if(t.field=='CAN'){
        return '80px'
     }else if(t.field=='RAM'){
      return '80px'
     }else if(t.field=='DataFlash'){
      return '80px'
     }else if(t.title=='USB'){
      return '80px'
     }else if(t.field=="Touchkey"){
      return '80px'
     }else if(t.field=="Fsys"){
      return '80px'
     }else if(t.field=="Core"){
      return '80px'
     }else if(t.title=='USB2.0 FS'){
      return '80px'
     }else if(t.title=='USB2.0 HS'){
      return '130px'
     }else if(t.field=='Freq/Max'){
        return '80px'
     }else if(t.field=='ADC'){
        return '80px'
     }else if(t.field=="Timer"){
      if(item.id==68){//低功耗蓝牙系列
        return '100px'
      }else{
        return '80px'
      }
     }else if(t.field=='Type-C'){
      return '80px'
     }else if(t.field=='USB_PD'){
      return '80px'
     }else if(t.field=='Advanced TM'){
      return '100px'
     }else if(t.field=="CodeROM"){
      return '130px'
     }else if(t.field=="DataRAM"){
      return '100px'
     }else if(t.field=="VDD/V"){
      return '120px'
     }else if(t.field=="LEDC/RGB LED"){
      return '120px'
     }else if(t.field=="UART/SPI/IIC"){
      return '120px'
     }else if(t.field=="RTC/WDOG"){
      return '120px'
     }else if(t.field=='Ethernet'){
      if(item.id==68){//低功耗蓝牙系列
        return '80px'
      }else{
        return '130px'
      }
     }else if(t.field=="Other_Fea"){
      return '130px'
     }else if(t.field=="Built-in OSC/WDOG"){
      return '150px'
     }else if(t.field=="Temperature"){
      return '150px'
     }else if(t.field=="TouchKey/ADC"){
      return '150px'
     }else if(t.title=='USB3.0/2.0(含PHY)'){
      return '150px'
     }else if(t.field=='GP_Timer'){
      return '160px'
     }else if(t.field=='ADC Unit_CH'){
      return '160px'
     }else if(t.field=="SERDES/HSPI/DVP"){
      return '170px'
     }else if(t.field=="App"){
      if(item.id==70){//最后
        return '260px'
      }else{
        return '230px'
      }
     }else if(t.field=="Package"){
      return 'auto'
      // if(item.categoryId==70 || item.categoryId==71 || item.categoryId==76 ){
      //   return '160px'
      // }
      // // else if(item.categoryId==75 ){
      // //   return '180px'
      // // }
      // else{
      //   return 'auto'
      // }
     }else{
      return t.width
     }

    },

    //设置部分单元格样式
    cellClassName(scope){
      if(scope.column.property=='UART'){
        if(scope.row['Part_NO']=='CH32V303RCT6'||scope.row['Part NO.']=='CH32V303RCT6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32V303VCT6'||scope.row['Part NO.']=='CH32V303VCT6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32V307RCT6'||scope.row['Part NO.']=='CH32V307RCT6'){
          return 'greenCell'
         }else if(scope.row['Part_NO']=='CH32V307WCU6'||scope.row['Part NO.']=='CH32V307WCU6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32V307VCT6'||scope.row['Part NO.']=='CH32V307VCT6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32F203RCT6'||scope.row['Part NO.']=='CH32F203RCT6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32F203VCT6'||scope.row['Part NO.']=='CH32F203VCT6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32F207VCT6'||scope.row['Part NO.']=='CH32F207VCT6'){
          return 'greenCell'
        }
      }
      if(scope.column.property=='USB_20H'||scope.column.property=='USB2.0 HS'){
        if(scope.row['Part_NO']=='CH32V305FBP6'||scope.row['Part NO.']=='CH32V305FBP6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32V305RBT6'||scope.row['Part NO.']=='CH32V305RBT6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32V307RCT6'||scope.row['Part NO.']=='CH32V307RCT6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32V307WCU6'||scope.row['Part NO.']=='CH32V307WCU6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32V307VCT6'||scope.row['Part NO.']=='CH32V307VCT6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32F205RBT6'||scope.row['Part NO.']=='CH32F205RBT6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32F207VCT6'||scope.row['Part NO.']=='CH32F207VCT6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32V305GBU6'||scope.row['Part NO.']=='CH32V305GBU6'){
          return 'greenCell'
        }
      }
      if(scope.column.property=='BLE'){
        if(scope.row['Part_NO']=='CH32V208GBU6'||scope.row['Part NO.']=='CH32V208GBU6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32V208CBU6'||scope.row['Part NO.']=='CH32V208CBU6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32V208RBT6'||scope.row['Part NO.']=='CH32V208RBT6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32V208WBU6'||scope.row['Part NO.']=='CH32V208WBU6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32F208RBT6'||scope.row['Part NO.']=='CH32F208RBT6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32F208WBU6'||scope.row['Part NO.']=='CH32F208WBU6'){
          return 'greenCell'
        }
      }
      if(scope.column.property=='LEDC/RGB LED'){
        if(scope.row['Part_NO']=='CH545'||scope.row['Part NO.']=='CH545'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH555'||scope.row['Part NO.']=='CH555'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH557'||scope.row['Part NO.']=='CH557'){
          return 'greenCell'
        } 
      }
      if(scope.column.property=='Ethernet'){
        // console.log('scope',scope)
        if(scope.row['Part_NO']=='CH578'||scope.row['Part NO.']=='CH578'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH579'||scope.row['Part NO.']=='CH579'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32V208GBU6'||scope.row['Part NO.']=='CH32V208GBU6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32V208RBT6'||scope.row['Part NO.']=='CH32V208RBT6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32V208WBU6'||scope.row['Part NO.']=='CH32V208WBU6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32F208RBT6'||scope.row['Part NO.']=='CH32F208RBT6'){
          return 'greenCell'
        } else if(scope.row['Part_NO']=='CH32F208WBU6'||scope.row['Part NO.']=='CH32F208WBU6'){
          return 'greenCell'
        }   
      }

    },

    //自定义表头样式
    getHeadClass({rowIndex}){
      if(rowIndex==0){
        return 'background-color:#4f78b4;color:#fff;font-size:13px;text-algin:center;font-weight:700;word-wrap: break-word;word-break:normal; '
      }
      else{
        return "color:#666; font-size:12px;text-algin:center; background-color:#fff;break-word;word-break:normal; "
      }
    },
    //设置斑马纹颜色
    tableRowClassName({row, rowIndex}) {
      // 通过rowIndex判断，然后返回特定的类名
      if (rowIndex % 2 === 0) {
        return 'even-row';
      } else {
        return 'odd-row';
      }
    },

    // 返回主页面
    returnHome(){
      window.location.href='https://www.wch-ic.com/'
    },
  



    // 导出数据
    downloadImage(){
      if(this.loading_export==true){
        return
      }else{
        let  fileName = 'MCU选型'
        this.handleExport(fileName)//调用函数
      }
    },
    handleExport(fileName){
      this.loading_export=true
      downFile(this.url.downloadUrl).then(res=>{
        if(res.message){
          return  this.$message.warning(res.message)
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([res],{type: 'application/vnd.ms-excel'}), fileName+'.xlsx')
        }else{
          debugger
          let url = window.URL.createObjectURL(new Blob([res],{type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName+'.xlsx')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
        this.loading_export=false
      })
    },

     
     
      
  }
};
</script>
<style scoped lang='less'>
.container {
  width: 88%;
  margin: 0 auto;
  margin-top: 20px;
  background: #fff;
  position: relative;
}
.topBtnPart{
  display: flex;
  /* margin-bottom: -35px;
  justify-content:flex-end; */
  /* position: absolute;
  right: 0px;
  top: 10px; */
}
.topBtn{
  border: 1px solid #1890ff;
  padding: 5px 10px;
  color: #1890ff;
  font-size: 13px;
  cursor: pointer;
}
.tableTitle{
  color: #00418c;
  font-size: 30px;
  text-align: left;
  font-weight: 600;
  margin-bottom: 10px;
}
.tableContainer{
  margin-top: 40px;
}
/* .tableContainer ::v-deep.el-table td.el-table__cell, ::v-deep.el-table th.el-table__cell.is-leaf{
    border-bottom: 2px solid #8ca558;
} */

.tableContainer /deep/.el-table .cell{
  padding-left: 0px;
  padding-right: 0px;
  line-height: 16px;
}
.tableContainer /deep/.el-table--border .el-table__cell:first-child .cell{
  padding-left: 0px;
}
.tableContainer /deep/.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    padding: 5px 0px;
}
.tableContainer /deep/.el-table--border, .el-table--group{
}
.tableContainer /deep/.el-table th.el-table__cell>.cell{
    letter-spacing: -1px;
}
.tableContainer ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
	background: #E3E3E2 ;
}
.tableContainer ::v-deep.el-table {
  font-size: 12px;
}
.cellClass{
  word-wrap: break-word;
  word-break:normal;
  font-weight: 600;
}
.tableContainer /deep/.even-row {
  background-color: #fff; /* 偶数行的背景色 */
}
.tableContainer /deep/.odd-row {
  background-color: #e6ecf6; /* 奇数行的背景色 */
}

.tableContainer /deep/.el-table .el-table__body td,
.tableContainer /deep/.el-table .el-table__body th{
    border: 2px solid #b8ceeb;

    border-left: 1px solid #fff;
    border-right: 2px solid #fff;
    position: relative;
    &::before {
        content: '';
        position: absolute;
        left: -1px;
        bottom: 0;
        width: 1px;
        height: 50px;
        background-color: #ffffff;
    }
    &::after {
        content: '';
        position: absolute;
        right: -2px;
        bottom: 0;
        width: 2px;
        height: 50px;
        background-color: #ffffff;
    }
}
.tableContainer /deep/.el-table thead tr th{
    border: 2px solid #b8ceeb;

    border-left: 1px solid #fff;
    border-right: 2px solid #fff;
    position: relative;
    &::before {
        content: '';
        position: absolute !important;
        left: -1px !important;
        bottom: 0 !important;
        width: 1px !important;
        height: 50px !important;
        background-color: #ffffff !important;
    }
    &::after {
        content: '';
        position: absolute !important;
        right: -2px !important;
        bottom: 0 !important;
        width: 2px !important;
        height: 50px !important;
        background-color: #ffffff !important;
    }
}
.tableContainer /deep/.el-table{
    border: 1px solid #b8ceeb;
    border-right: 2px solid #b8ceeb;
    border-bottom: none;

    border-left: 1px solid #fff;
    border-right: 2px solid #fff;
}
.tableContainer ::v-deep.el-table td.el-table__cell, ::v-deep.el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #b8ceeb;
}
.tableContainer /deep/.greenCell{
  // background: #b7d972a3 !important;
}

.bottomTips{
    font-size: 16px;
    line-height: 10px;
    text-align: left;
    color: #333;
}
@media  (max-width:585px){
  .topBtnPart{
    display: flex;
    margin-bottom: -35px;
    justify-content:flex-end;
    /* position: absolute;
    right: 0px;
    top: 10px; */
  }
}
@media  (min-width:584px){
  .topBtnPart{
    display: flex;
    /* margin-bottom: -35px;
    justify-content:flex-end; */
    position: absolute;
    right: 0px;
    top: 10px;
  }
}

/* 2K屏 */
@media (min-width: 2000px) and (max-width:2700px){
  .container {
    width: 70%;
  }
}
/* 4K屏 */
@media (min-width: 2701px) and (max-width:3900px){
  .container {
    width: 48%;
  }
}
/* 大于4K屏 */
@media (min-width: 3901px) {
  .container {
    width: 1840px;
  }
}


</style>
